import { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from '../../../types/default-cloud-graph-design-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { MiroIcon, MiroSearchResultIcon } from './icon';

export const miroConfig: ThirdPartyConfig = {
	displayName: 'Miro',
	id: 'miro',
	resourceType: ProductResourceTypes3P.Miro,
	icon: get3PLogo(MiroIcon, 'Miro', 'medium'),
	searchResultIcon: get3PLogo(MiroSearchResultIcon, 'Miro', 'large'),
	integrationAri: 'ari:cloud:platform::integration/miro',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
